import  {i18n}  from  '../language'

export function CarCoupleStatusDesc(status) {
  var prefix ='Enum.CarCoupleStatus.';
  const map = {
  0: prefix+'Disconnected',
  1: prefix+'HalfConnected',
  2: prefix+'Connected'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}


export function EquipmentTypeDesc(status) {
  var prefix ='Enum.EquipmentType.';
  const map = {
  1: prefix+'DCCharger',
  2: prefix+'ACCharger',
  3: prefix+'ACDCIntegrated',
  4: prefix+'WirelessCharger',
  5: prefix+'DCMoveCharger',
  255: prefix+'Other'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function NationalStandardDesc(status) {
   var prefix ='Enum.NationalStandard.';
  const map = {
  1: prefix+'GB_2011',
  2: prefix+'GB_2015',
  3: prefix+'HighPowerAC',
  255: prefix+'Other'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function ConnectorTypeDesc(status) {
  var prefix ='Enum.ConnectorType.';
  const map = {
  1: prefix+'HouseholdSocket',
  2: prefix+'AcSocket',
  3: prefix+'AcPlug',
  4: prefix+'DcPlug',
  5: prefix+'WirelessSocket',
  6: prefix+'DcEnergyStorage',
  255: 'Other'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}


export function StationStatusDesc(status) {
  var prefix ='Enum.StationStatus.';
  const map = {
  0: prefix+'Unknow',
  1: prefix+'Constructing',
  5: prefix+'CloseDown',
  6: prefix+'Maintaining',
  50: prefix+'Normal'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function EquipmentStatusDesc(status) {
  var prefix ='Enum.EquipmentStatus.';
  const map = {
  0: prefix+'Unknow',
  1: prefix+'Constructing',
  5: prefix+'CloseDown',
  6: prefix+'Maintaining',
  50: prefix+'Normal'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}


export function WorkStatusDesc(status) {
  var prefix ='Enum.WorkStatus.';
  const map = {
   0: prefix+'Standby',
   1: prefix+'ChargeStarting',
   2: prefix+'Charging',
   3: prefix+'ChargeFinished',
   4: prefix+'ChargeFailed',
   5: prefix+'PlatformDisabled',
   6: prefix+'Alarming',
  10: prefix+'Ordered',
 '-1': prefix+'Offline'
  }
  if(status ==-1){
   return  i18n.t('Enum.WorkStatus.Offline');
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function StationTypeDesc(status) {
  var prefix ='Enum.StationType.';
  const map = {
  1: prefix+'Public',
  50: prefix+'Personal',
  100: prefix+'Bus',
  101: prefix+'Sanitation',
  102: prefix+'Logistics',
  103: prefix+'Taxi',
  255: prefix+'Other'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function StationPropertyDesc(status) {
  var prefix ='Enum.StationProperty.';
  const map = {
  1: prefix+'CarChargingStation',
  2: prefix+'ElectricMotorcycleChargingStation'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function ConstructionTypeDesc(status) {
  var prefix ='Enum.ConstructionType.';
  const map = {
  1: prefix+'Neighborhood',
  2: prefix+'PublicInstitution',
  3: prefix+'Enterprises',
  4: prefix+'OfficeBulding',
  5: prefix+'IndustryPark',
  6: prefix+'TrafficHinge',
  7: prefix+'ArtsSportsInfrastructure',
  8: prefix+'UrbanGreenSpace',
  9: prefix+'ParkingLot',
  10: prefix+'StreetParkingSpace',
  11: prefix+'HighSpeedServiceArea',
  255: prefix+'Other',
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}


export function MemberStatusDesc(status) {
  var prefix ='Enum.MemberStatus.';
  const map = {
  0: prefix+'Normal',
  1: prefix+'Locked',
  256: prefix+'Lost',
  512: prefix+'Disabled',
  1024: prefix+'Blacklist',
  4096: prefix+'Verifying'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function PaymentWayDesc(status) {
  var prefix ='Enum.PaymentWay.';
  const map = {
  0: prefix+'None',
  1: prefix+'PrePaid',
  2: prefix+'BalancePaid',
  11: prefix+'AlipayCredit',
  12: prefix+'WeixinCredit',
  98: prefix+'PayFromGroup'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function TransTypeDesc(status) {
  var prefix ='Enum.TransType.';
  const map = {
  1: prefix+'Recharge',
  2: prefix+'Refund',
  3: prefix+'Consume',
  4: prefix+'Given',
  11: prefix+'Prepay',
  12: prefix+'PrepayConsume',
  13: prefix+'PrepayRefund',
  21: prefix+'OccupyConsume',
  22: prefix+'OccupyDerate'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function PaymentModeDesc(status) {
  var prefix ='Enum.PaymentMode.';
  const map = {
  0: prefix+'Unknown',
  1: prefix+'Alipay',
  5: prefix+'WeixinMp',
  6: prefix+'WinxinMini',
  10: prefix+'TrustPayAbc',
  90: prefix+'PersonalEquip',
  98: prefix+'OnlineVin',
  99: prefix+'OnlineCard',
  100: prefix+'Evcs'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function ChargeOrderStatusDesc(status) {
  var prefix ='Enum.ChargeOrderStatus.';
  const map = {
0: prefix+"None",
1: prefix+"OrderStart",
2: prefix+"OnlineCardAuthSucced",
3: prefix+"OnlineCardAuthFailed",
6: prefix+"AppointCharging",
11: prefix+"PaymentCreateSucced",
12: prefix+"PaymentCreateFailed",
13: prefix+"PaymentRequestSucced",
14: prefix+"PaymentRequestFailed",
15: prefix+"PaymentPreparedPay",
16: prefix+"PaymentWaitForPayResult",
17: prefix+"PaymentPaySucced",
18: prefix+"PaymentPayFailed",
19: prefix+"PaymentPayTimeout",
20: prefix+"OrderClosed",
21: prefix+"SendStartCmdSucced",
22: prefix+"SendStartCmdFailed",
25: prefix+"ChargeStarting",
26: prefix+"StartCmdResultSucced",
27: prefix+"StartCmdResultFailed",
29: prefix+"StartCmdResultTimeout",
30: prefix+"Charging",
31: prefix+"SendStopCmdSucced",
32: prefix+"SendStopCmdFailed",
35: prefix+"ChargeStopping",
39: prefix+"ChargeFinished",
41: prefix+"Settling",
42: prefix+"SettleFinished",
45: prefix+"SettleFailed",
51: prefix+"RefundCreateSucced",
52: prefix+"RefundCreateFailed",
53: prefix+"RefundRequestSucced",
54: prefix+"RefundRequestFailed",
55: prefix+"Refunding",
56: prefix+"RefundSucced",
57: prefix+"RefundFailed",
9999: prefix+"OrderFinished",

  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function StartModeDesc(status) {
  var prefix ='Enum.StartMode.';
  const map = {
  0: prefix+'OfflineCard',
  1: prefix+'OnlineCard',
  2: prefix+'OfflineVin',
  3: prefix+'OnlineVin',
  4: prefix+'PhysicalButtons',
  5: prefix+'ScreenStart',
  6: prefix+'LocalOrder',
  7: prefix+'PlatformOrder',
  48: prefix+'Platform'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function SettleTypeDesc(status) {
  var prefix ='Enum.SettleType.';
  const map = {
  0: prefix+'Unknown',
  1: prefix+'AutoSettle',
  2: prefix+'ManualSettle'
  }
  const key = map[status]
  return key ? i18n.t(key) : 'UnKown'
}

export function registerEnumFilters(Vue) {
  Vue.filter('CarCoupleStatusDesc', CarCoupleStatusDesc)
  Vue.filter('WorkStatusDesc', WorkStatusDesc)
  Vue.filter('EquipmentTypeDesc', EquipmentTypeDesc)
  Vue.filter('ConnectorTypeDesc', ConnectorTypeDesc)
  Vue.filter('StationStatusDesc', StationStatusDesc)
  Vue.filter('StationTypeDesc', StationTypeDesc)
  Vue.filter('StationPropertyDesc', StationPropertyDesc)
  Vue.filter('ConstructionTypeDesc', ConstructionTypeDesc)
  Vue.filter('EquipmentStatusDesc', EquipmentStatusDesc)
  Vue.filter('NationalStandardDesc', NationalStandardDesc)
  Vue.filter('MemberStatusDesc', MemberStatusDesc)
  Vue.filter('ChargeOrderStatusDesc', ChargeOrderStatusDesc)
  Vue.filter('PaymentModeDesc', PaymentModeDesc)
  Vue.filter('PaymentWayDesc', PaymentWayDesc)
  Vue.filter('TransTypeDesc', TransTypeDesc)
  Vue.filter('StartModeDesc', StartModeDesc)
  Vue.filter('SettleTypeDesc', SettleTypeDesc)
  
}

//this.$options.filters.CarCoupleStatusDesc(this.status)
//{{ currentCoupleStatus | CarCoupleStatusDesc }}